import React from 'react'

const TripPlanTableComponentLoadable = React.lazy(() => import('./TripPlanTableNew'));
const AddTripPlanComponentLoadable = React.lazy(() => import('./AddTripPlanComponent'));
const EditTripPlanComponentLoadable = React.lazy(() => import('./EditTripPlanComponent'));
const TripPlanTabsComponentLoadable = React.lazy(() => import('./TripPlanTabComponent'));
const TripPlanWaybillTableComponentLoadable = React.lazy(() => import('./TripPlanWaybillTableComponent'));
const TripPlanFileComponentLoadable = React.lazy(() => import('./Files/TripPlanFileComponent'));
const TripPlanBanTableComponentLoadable = React.lazy(() => import('./TripPlanBanTableComponent'));
const TripPlanGeneratingOTPComponentLoadable = React.lazy(() => import('./TripPlanGeneratingOTPComponent'));
const TripExceptionComponentLoadable = React.lazy(() => import('./TripExceptionComponent'));


export {
    TripPlanTableComponentLoadable,
    AddTripPlanComponentLoadable,
    EditTripPlanComponentLoadable,
    TripPlanTabsComponentLoadable,
    TripPlanWaybillTableComponentLoadable,
    TripPlanFileComponentLoadable,
    TripPlanBanTableComponentLoadable,
    TripPlanGeneratingOTPComponentLoadable,
    TripExceptionComponentLoadable
}